import React, { useState, useEffect, useContext } from "react";
import { Link, useParams } from "react-router-dom";
import db from "../../../../api/mongodb";
import { Container, Row, Col, Image, Card, Button } from "react-bootstrap";
import { defaultOptions1 } from "../../../../config/loading-config.js";
import Lottie from "react-lottie";
import "./SafeAPProfile.scss";
import SafeAPProfileListSection from "./SafeAPProfileListSection";
import ProfileTabs from "../../../ProfileTabs";
import dummyProfilePicture from "../../../../images/dummy-profile-picture.svg";
import { UserContext } from "../../../../api/UserProvider";
import { clearanceDecoder, formatPhoneNumber, prefixDecoder } from "../../directory/logic/utils";
import { Grid } from "@mui/material";
import PrivacySettingsPopup from "./PrivacySettingsPopup";

const SafeAPProfile = () => {
    const [isLoading, setIsLoading] = useState(true);
    const [actprojects, setAProjects] = useState([]);
    const [comprojects, setCProjects] = useState([]);
    const [courses, setCourses] = useState([]);
    const [safeAP, setSafeAP] = useState({});
    const [safeApStatus, setSafeApStatus] = useState("");
    const [registrationDate, setRegistrationDate] = useState("");
    const { id } = useParams();
    const user = useContext(UserContext)
    const [showPopup, setShowPopup] = useState(false)
    const [isSafeApPrivate, setIsSafeApPrivate] = useState(true)



    useEffect(() => {
        apiCall();
    }, []);

    // console.log(safeApStatus);

    const apiCall = () => {
        db.get(`/api/safeAPs/${id}`, {
            headers: {
                Authorization: `${localStorage.getItem("token")}`,
            },
        }).then(
            (response) => {
                // console.log(response.data)
                setSafeAP(response.data);
                setSafeApStatus(response.data.status);
                setIsSafeApPrivate(response.data.hiddenFromPublic)

                const primary = response.data.projects.primary;
                const secondary = response.data.projects.secondary;
                const allProjects = primary.concat(secondary);
                const allCourses = [];

                if (response.data.formData.courses) {
                    response.data.formData.courses.map((entry) => {
                        allCourses.push(entry.id);
                    });
                }

                convertDate(response.data.createdAt);

                db.put(
                    "/api/projects/find/multiple?page=0&limit=1000&status=active",
                    { ids: allProjects },
                    {
                        headers: {
                            Authorization: `${localStorage.getItem("token")}`,
                        },
                    }
                ).then(
                    (response) => {
                        let active = [];
                        let completed = [];
                        for (let i = 0; i < response.data.projects.length; i++) {
                            if (response.data.projects[i].status === "active")
                                active.push(response.data.projects[i]);
                            else completed.push(response.data.projects[i]);
                        }
                        setAProjects(response.data.projects);

                        db.put(
                            "/api/projects/find/multiple?page=0&limit=1000&status=completed",
                            { ids: allProjects },
                            {
                                headers: {
                                    Authorization: `${localStorage.getItem("token")}`,
                                },
                            }
                        ).then(
                            (response) => {
                                setCProjects(response.data.projects);
                            },
                            (error) => { }
                        );

                        db.put(
                            "/api/courses/find/multiple",
                            { ids: allCourses },
                            {
                                headers: {
                                    Authorization: `${localStorage.getItem("token")}`,
                                },
                            }
                        ).then(
                            (response) => {
                                setCourses(response.data);
                                setIsLoading(false);
                            },
                            (error) => { }
                        );
                    },
                    (error) => { }
                );
            },
            (error) => { }
        );
    };

    const convertDate = (resDate) => {
        var date = resDate.toString().substring(0, 10);
        setRegistrationDate(date);
    };

    const toggleSafeApStatus = (e) => {
        e.preventDefault();
        db.put(
            `/api/safeAPs/${id}`,
            { status: safeApStatus === "approved" ? "blocked" : "approved" },
            {
                headers: {
                    Authorization: `${localStorage.getItem("token")}`,
                },
            }
        ).then((repsonse) => {
            setSafeApStatus(safeApStatus === "approved" ? "blocked" : "approved");

        })
            .catch((err) => { });
    };

    const toggleSafeApPrivacy = (e) => {
        e.preventDefault();
        db.put(
            `/api/safeAPs/${id}`,
            { hiddenFromPublic: !isSafeApPrivate },
            {
                headers: {
                    Authorization: `${localStorage.getItem("token")}`,
                },
            }
        ).then((repsonse) => {
            setIsSafeApPrivate(!isSafeApPrivate);

        })
            .catch((err) => { });
    };

    if (isLoading) {
        return <Lottie options={defaultOptions1} height={200} width={200} />;
    }

    // console.log(safeAP.formData)
    return (
        <div style={{ marginBottom: "50px" }}>
            <PrivacySettingsPopup handleCloseModal={() => {
                setShowPopup(false)
            }} showPopup={showPopup} safeAPId={id}
                toggleSafeApPrivacy={toggleSafeApPrivacy}
                isSafeApPrivate={isSafeApPrivate}
            />
            <Container fluid >

                <div style={{ position: "relative", backgroundColor: "#112c54", height: 380, borderRadius: "10px", boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px" }}>

                    <div className="safe-ap-profile-img">
                        <img
                            src={
                                safeAP.formData.img && safeAP.formData.img.length
                                    ? safeAP.formData.img[0].content
                                    : dummyProfilePicture
                            }

                        ></img>
                    </div>



                    <Card className="safe-ap-profile-main-section" style={{ position: "absolute", top: "50%", height: "50%", width: "100%", borderRadius: "10px" }}>
                        <Card.Body className="safe-profile-flex" >

                            <div className="safe-ap-profile-main-info" >
                                <div>
                                    <h1>
                                        {" "}
                                        {prefixDecoder(safeAP.formData.prefix)}{safeAP.formData.firstName} {safeAP.formData.lastName}
                                    </h1>
                                    <br />

                                    <div>

                                        {safeAP.formData.email}
                                    </div>
                                </div>
                                {/* <div className="safe-ap-main-section-subtitle">
                                Since {registrationDate}
                            </div>
                            <div className="safe-ap-main-section-content">
                                <div>
                                   
                                    {safeAP.location.address} {safeAP.location.zipPostalCode},{" "}
                                    {safeAP.location.city}, {safeAP.location.stateProvince},{" "}
                                    {safeAP.location.country}
                                </div>
                                <div>
                                   
                                    {safeAP.contact.email}
                                </div>
                                <div>
                                   
                                    {safeAP.contact.phone}
                                </div>
                            </div> */}
                            </div>
                        </Card.Body>
                    </Card>
                </div>


                <div>
                    &nbsp;
                </div>
                <div className="safeap-profile-button-group">
                    <Link to={`/safeAPs/profile/edit/${id}`}>
                        <Button className="edit-profile-btn"> Edit Profile </Button>
                    </Link>


                    {user.role === "admin" && (
                        <>
                            <div>
                                <Button
                                    className={`edit-profile-btn ${safeApStatus === "approved" ? "disabled" : ""
                                        }`}
                                    variant="success"
                                    onClick={toggleSafeApStatus}
                                >
                                    {"Approve SafeAP"}
                                </Button>
                            </div>
                            <div>
                                <Button
                                    className={`edit-profile-btn ${safeApStatus === "blocked" ? "disabled" : ""
                                        }`}
                                    variant="success"
                                    onClick={toggleSafeApStatus}
                                >
                                    {"Block SafeAP"}
                                </Button>
                            </div>
                        </>
                    )}

                    <div>
                        &nbsp;
                    </div>
                    <Button className="edit-profile-btn" onClick={() => {
                        setShowPopup(true)
                    }}>Privacy Settings</Button>

                    
                    
                </div>
                <Row>
                    <Col>
                        <Card className="safe-ap-profile-subsection" >


                            <Card.Body>
                                <div>
                                    <h4>SafeAP Information</h4>

                                </div>
                                <hr></hr>
                                <div className="safeap-information-section">
                                    <h6>Since</h6>
                                    {registrationDate}
                                </div>

                                <div className="safeap-information-section">
                                    <h6>Address</h6>

                                    {safeAP.formData.address} {safeAP.formData.zipPostalCode},{" "}
                                    {safeAP.formData.city}, {safeAP.formData.stateProvince},{" "}
                                    {safeAP.formData.country}
                                </div>

                                <div className="safeap-information-section">
                                    <h6>Phone</h6>
                                    {formatPhoneNumber(safeAP.formData.phone)}
                                </div>

                                {
                                    safeAP.formData.safeap_service_area &&
                                    <div className="safeap-information-section">
                                        <h6>SafeAP Service Area</h6>
                                        {safeAP.formData.safeap_service_area}
                                    </div>
                                }

                                {
                                    safeAP.formData.professional_designation &&
                                    <div className="safeap-information-section">
                                        <h6>Professional Designations</h6>
                                        {safeAP.formData.professional_designation}
                                    </div>
                                }
                                {
                                    clearanceDecoder(safeAP.formData.security_clearance) ?
                                        <div className="safeap-information-section">
                                            <h6>Security Clearance</h6>
                                            {clearanceDecoder(safeAP.formData.security_clearance)}
                                        </div> :
                                        null
                                }

                            </Card.Body>
                        </Card>
                        <br />
                        <CardSection header={"Safe accredited courses"} array={safeAP.formData.courses ? safeAP.formData.courses : []} />
                        <br />
                        <CardSection header={"Education"} array={safeAP.formData.education ? safeAP.formData.education : []} />
                        <br />
                        <CardSection header={"Security related courses"} array={safeAP.formData.security_education ? safeAP.formData.security_education : []} />
                    </Col>
                    <Col>
                        <Card className="safe-ap-profile-subsection" >
                            <Card.Body>
                                <div className="safe-ap-profile-list-wrapper">
                                    <h4>Projects created by SafeAP</h4> 
                                    <div className="safe-ap-profile-list-content">
                                        <ProfileTabs>
                                            <div label="Active">
                                                <SafeAPProfileListSection
                                                    listItems={actprojects}
                                                    isProject={true}
                                                />
                                            </div>
                                            <div label="Completed">
                                                <SafeAPProfileListSection
                                                    listItems={comprojects}
                                                    isProject={true}
                                                />
                                            </div>
                                        </ProfileTabs>
                                    </div>
                                </div>
                            </Card.Body>


                        </Card>
                    </Col>

                </Row>



            </Container>

        </div>
    );
};

export const CardSection = ({ header, array }) => {
    // console.log(array)
    return (
        <Card className="safe-ap-profile-subsection" >
            <Card.Body>
                <div className="safe-ap-profile-list-wrapper">
                    <h4>{header}</h4>

                </div>
                <hr></hr>
                {array.length === 0 &&
                    `Nothing to show for ${header}`
                }
                {
                    array.map((element, i) => {
                        return (
                            <Container key={i} style={{ marginBottom: "20px" }}>
                                <Grid container spacing={2}>
                                    <Grid item flexGrow={1} className="safeap-information-section">
                                        <h6>Name:</h6>
                                    </Grid>
                                    <Grid item className="safeap-information-section">
                                        <h6>Date Completed:</h6>
                                    </Grid>
                                </Grid>
                                <Grid container spacing={2}>
                                    <Grid item flexGrow={1}>
                                        {element.name}
                                    </Grid>
                                    <Grid item>
                                        {element.dateCompleted}
                                    </Grid>
                                </Grid>
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                <span style={{ fontSize: "12.5px", color: "grey" }}>
                                    {
                                        element.degree && element.field ?
                                            `${element.degree + ", " || ''}${element.field || ''}` :
                                            null
                                    }
                                </span>

                            </Container>
                        )
                    })
                }
            </Card.Body>
        </Card>)
}

export default SafeAPProfile;
